import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Le picker s'ouvre uniquement via l'icône native (gérée en CSS).
// La saisie clavier reste libre sur le reste de l'input — pas de showPicker global.

createRoot(document.getElementById("root")!).render(<App />);
